// extracted by mini-css-extract-plugin
export default {"HomeVideo":"HomeVideo_HomeVideo__z-E0w","iframe":"HomeVideo_iframe__B6Vqn"};